import styled from "styled-components"

export const ButtonBlue = (props: { 
    text: string,
    onClick?: () => void
}) => {

    return (
        <Root onClick={props.onClick ?? props.onClick}>{props.text}</Root>
    )
}

const Root = styled.button`
    font-size: 20px;
    font-weight: 900;
    color: #054654;
    width: 100%;
    padding: 8px;
    background-color: #ADE0EB;
    border-radius: 8px;
    border: 0;
    border-bottom: 5px solid #0F8199;
    cursor: pointer;

    &:active{
        background-color: #7CCDDF;
        border-bottom: 3px solid #0F8199;
        margin-top: 2px;
    }
`;